module.exports = __webpack_public_path__ + "img/超高频.2765e205.jpg";